module.exports = __webpack_public_path__ + "img/yajirushi_haikei1.08fd0908.png";